import { Map as map } from 'immutable';
const C = require("../constants");

function ToastReducer(state = map(), action) {
    switch (action.type) {
        case C.SHOW_TOAST:
            return action.data;
        default:
            return state;
    }
};

export default ToastReducer;


// WEBPACK FOOTER //
// ./src/reducers/ToastReducer.js